<template>
<div id="social">
    <div id="social-block">
  <!-- Facebook -->
  <div class="social-btn"> <a href="https://www.facebook.com/soonnet/" target="_blank" class="social-icon facebook fab fa-facebook-f"> </a> </div>
  <!-- Instagram -->
  <div class="social-btn"> <a href="https://www.instagram.com/soonnettv/" target="_blank" class="social-icon instagram fab fa-instagram"> </a> </div>
  <!-- YouTube -->
  <div class="social-btn"> <a href="https://www.youtube.com/soonnettv" target="_blank" class=" social-icon youtube fab fa-youtube"> </a> </div>
</div>
</div>
</template>
<script>
export default {
  name: 'social',
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SocialButton.vue